import { ROUTE_NAMES } from '@/constant/routes'

const PAYMENT_ROUTES = [
  ROUTE_NAMES.UPGRADE_SUCCESS,
  ROUTE_NAMES.UPGRADE_BULK_SUCCESS,
  ROUTE_NAMES.UPGRADE,
  ROUTE_NAMES.STRIPE_TRANSITION,
]

const isPaymentPage = (state) => {
  return PAYMENT_ROUTES.includes(state.route.name)
}

export default {
  isPaymentPage,
}
